import React, { useContext } from 'react';
import { NoColorLink } from 'ui/NoColorLink';
import { Button, IconButton, Typography } from '@mui/material';
import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos';

import { HrSimulation } from 'routes/HumanResourcesModule/Simulation/helpers/types';
import {
    StyName,
    StySynthesisHeader,
} from 'routes/HumanResourcesModule/Simulation/SimulationSynthesis/components/SynthesisHeader/StyComponents';
import { MANTY_ORANGE } from 'styles/theme';
import HistoricalOrgChartHrContext from 'routes/HumanResourcesModule/Simulation/contexts/ObsoleteOrgChartSimulationContext';
import { HR_HOME_PAGE_URL } from 'components/App/components/routes';
import { ObsoleteInfoBox } from 'routes/HumanResourcesModule/components/ui/ObsoleteInfoBox';
import SimulationTypeChip from 'routes/HumanResourcesModule/Simulation/SimulationHome/components/SimulationItem/SimulationTypeChip';
import Flex from 'ui/Flex/Flex';
import OrgChartChips from 'routes/HumanResourcesModule/components/OrgChartChips';
import { useTranslation } from 'react-i18next';

type Props = {
    hrSimulation: HrSimulation;
    setShowSimulationModal: (v: boolean) => void;
    setDuplicateMode: (v: boolean) => void;
};

function SynthesisHeader({
    hrSimulation,
    setShowSimulationModal,
    setDuplicateMode,
}: Props): React.ReactElement {
    const { t } = useTranslation();
    const { data: obsoleteOrgChartHr } = useContext(
        HistoricalOrgChartHrContext,
    );
    const obsoleteOrgChartHrLength =
        obsoleteOrgChartHr &&
        Object.keys(obsoleteOrgChartHr).length > 0 &&
        obsoleteOrgChartHr[hrSimulation.id.toString()]
            ? obsoleteOrgChartHr[hrSimulation.id.toString()].length
            : 0;
    return (
        <StySynthesisHeader>
            <StyName>
                <Flex gap="1rem">
                    <NoColorLink to={`${HR_HOME_PAGE_URL}/simulation_home`}>
                        <IconButton sx={{ padding: 0 }}>
                            <ArrowBackIosIcon fontSize="small" />
                        </IconButton>
                    </NoColorLink>
                    <Typography variant="h4" sx={{ display: 'flex' }}>
                        {hrSimulation.title}
                    </Typography>
                    <SimulationTypeChip type={hrSimulation.type} />
                </Flex>
            </StyName>
            <OrgChartChips item={hrSimulation} />
            {obsoleteOrgChartHrLength > 0 && (
                <ObsoleteInfoBox>
                    {t('humanResources.simulation.obsoleteHeader')}
                    <Button
                        sx={{
                            fontSize: '0.7rem',
                            backgroundColor: MANTY_ORANGE,
                            '&:hover': {
                                backgroundColor: 'rgba(233, 129, 95, 1)',
                            },
                        }}
                        onClick={() => {
                            setShowSimulationModal(true);
                            setDuplicateMode(false);
                        }}
                        variant="contained"
                    >
                        {t('humanResources.simulation.newSimulation')}
                    </Button>
                    <Button
                        sx={{
                            fontSize: '0.7rem',
                            backgroundColor: MANTY_ORANGE,
                            '&:hover': {
                                backgroundColor: 'rgba(233, 129, 95, 1)',
                            },
                        }}
                        variant="contained"
                        onClick={() => {
                            setShowSimulationModal(true);
                            setDuplicateMode(true);
                        }}
                    >
                        {t(
                            'humanResources.simulation.duplicateSimulationTitle',
                        )}
                    </Button>
                </ObsoleteInfoBox>
            )}
        </StySynthesisHeader>
    );
}

export default SynthesisHeader;
